var Entities = require('Entities');
var Lookups = EY.Consultation.Lookups;

module.exports.run = function (options) {
    var approverList = new Entities.Approvers(options.approvers.reject({ upn: '' }));
    var approvers = new Entities.Approvers(approverList.reject({ approvalNotRequired: true }));
    var record = options.record;
    var current = approvers.find({ approverGroupId: record.get('approverGroupId'), upn: record.get('assignedTo') });
    var next = current.id != approvers.last().id ? approvers.at(approvers.findIndex(current) + 1) : null;
    var last = record.get('recordTypeId') === Lookups.RecordType.RequiredNotification ? Lookups.StatusType.UsersNotified : Lookups.StatusType.Complete;

    current.set('approval', new Date());
    record.set({
        assignedTo: next ? next.get('upn') : '',
        assignedToGivenName: next ? next.get('givenName') : '',
        approverGroupId: next ? next.get('approverGroupId') : '',
        completedOn: next || last === Lookups.StatusType.UsersNotified ? '' : new Date(),
        statusTypeId: next ? Lookups.StatusType.ReviewApproval : last
    });
    if (!next && last!= Lookups.StatusType.UsersNotified) {
        options.activities.reset();
        record.set('communication', '');
    }
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Action/RecordActionApprove.js